import { ApiException } from '@eta/components';
import { createAction } from 'redux-actions';
import { IntermediaryService } from '../../Services/Intermediary/Service';
import { ContactTypes, IntermediaryRepresentationsRequestDto, SubmitApplicationRequestDto, UpdateContactDetailsDto } from '../Service/proxy';
import { intermediariesCurrentApplication, intermediariesCurrentContactDetails, LoadCurrentIntermediary, LOAD_INTERMEDIARIES_LIST, ADD_INTERMEDIARY, LOAD_TAXPAYER_INTERMEDIARIES, changeAppStatus } from './Types';
import { OTPVerifyIntermediary } from '../../Verification/Redux/Types';


const intermediaryService = new IntermediaryService();


export const ChangeAppSatusAction = createAction(changeAppStatus, (content: boolean) => {
    return { IsRenew: content };
});


export const GetIntermediaries = createAction(
    LOAD_INTERMEDIARIES_LIST,
    async () => {

        try {
            return await intermediaryService.GetIntermediaries();
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);

export const getCurrentIntermediary = createAction(
    LoadCurrentIntermediary,
    async () => {

        try {
            return await intermediaryService.GetDetials();
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);

export const submitApplication = createAction(
    intermediariesCurrentApplication,
    async (body?: SubmitApplicationRequestDto) => {

        try {
            return await intermediaryService.SubmitApplication(body);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);


export const updateContactDetails = createAction(
    intermediariesCurrentContactDetails,
    async (body?: UpdateContactDetailsDto) => {

        try {
            return await intermediaryService.UpdateContactDetails(body);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);

export const validateContactDetails = createAction(
    OTPVerifyIntermediary,
    async (taxpayerID: number, oTPcode: string | null, contactType: ContactTypes) => {
        try {
            await intermediaryService.ValidationOTPcode(taxpayerID, oTPcode, contactType);
        } catch (serviceError) {
            return { lastError: serviceError };
        }
        return { lastError: null };
    }
);

export const verifyIntermediary = async (taxpayerID: number, oTPcode: string | null, contactType: ContactTypes) => {
    // eslint-disable-next-line no-return-await
    return await intermediaryService.ValidationOTPcode(taxpayerID, oTPcode, contactType);
};

export const getTaxpayerIntermediaries = createAction(
    LOAD_TAXPAYER_INTERMEDIARIES,
    async (name?: string | null | undefined, nameAr?: string | null | undefined, pageSize?: number | undefined, pageNumber?: number | undefined) => {

        try {
            return await intermediaryService.GetTaxpayerIntermediaries(name, nameAr, pageSize, pageNumber);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);

export const saveTaxpayerIntermediaries = createAction(
    ADD_INTERMEDIARY,
    async (body?: IntermediaryRepresentationsRequestDto | undefined) => {
        try {
            return await intermediaryService.SaveTaxpayerIntermediary(body);
        } catch (ex) {
            const apiException = ex as ApiException;
            return { lastError: apiException };
        }
    }
);


